import React, { Component } from 'react';

export default class SideBarMenuItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isActiveIndex:false
        };
        this.changeLocation = this.changeLocation.bind(this);
    }

    componentWillMount(){
        if(this.props.isActiveIndex){
            this.setState({isActiveIndex : this.props.isActiveIndex});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== null && this.props.isActiveIndex !== nextProps.isActiveIndex) {
            this.setState({isActiveIndex : nextProps.isActiveIndex});
        }
    }

    changeLocation(){
        this.props.changeLocation(this.props.locationIndex);
    }

    render() {
        let activeClassName = "";
        if(this.state.isActiveIndex){
             activeClassName = "active";
        }
        return (
            <a className = {`list-group-item ${activeClassName}`} onClick = {this.changeLocation}>
                <div className = "row">
                    <div className = "col-xs-2">
                        <i className = "material-icons md-36">location_on</i>
                    </div>
                    <div className = "col-xs-10">
                        <h4 className = "list-group-item-heading">{this.props.locName}</h4>
                        <p className = "list-group-item-text">{this.props.address}</p>
                    </div>
                </div>
            </a>
        );
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/sidebar/sidebar-menuitem.js